<template>
  <svg
    :class="{
      mt7: isActive && sortBy.toLowerCase() === 'asc',
      mb7: isActive && sortBy.toLowerCase() === 'desc',
    }"
    fill="none"
    viewBox="0 0 16 16"
  >
    <path
      v-show="(isActive && sortBy.toLowerCase() === 'desc') || !isActive"
      :fill="defaultColor"
      d="M4.40686 9.1058L7.82169 12.5921C7.84504 12.616 7.87279 12.6349 7.90333 12.6479C7.93387 12.6608 7.96661 12.6674 7.99967 12.6674C8.03274 12.6674 8.06548 12.6608 8.09602 12.6479C8.12656 12.6349 8.1543 12.616 8.17766 12.5921L11.5925 9.1058C11.6277 9.0699 11.6517 9.02413 11.6615 8.97429C11.6712 8.92444 11.6662 8.87277 11.6472 8.82582C11.6281 8.77887 11.5958 8.73875 11.5544 8.71056C11.513 8.68236 11.4643 8.66736 11.4145 8.66745H4.58484C4.53506 8.66736 4.48637 8.68236 4.44495 8.71056C4.40352 8.73875 4.37123 8.77887 4.35217 8.82582C4.3331 8.87277 4.32813 8.92444 4.33786 8.97429C4.3476 9.02413 4.37161 9.0699 4.40686 9.1058Z"
    />
    <!-- :fill="sortBy.toLowerCase() === 'desc' && isActive ? activeColor : defaultColor" -->
    <path
      v-show="(isActive && sortBy.toLowerCase() === 'asc') || !isActive"
      :fill="defaultColor"
      d="M4.4069 6.89564L7.82173 3.40938C7.84509 3.38548 7.87283 3.36652 7.90337 3.35358C7.93391 3.34064 7.96665 3.33398 7.99972 3.33398C8.03278 3.33398 8.06552 3.34064 8.09606 3.35358C8.1266 3.36652 8.15435 3.38548 8.1777 3.40938L11.5925 6.89564C11.6278 6.93153 11.6518 6.9773 11.6615 7.02715C11.6713 7.07699 11.6663 7.12866 11.6472 7.17562C11.6282 7.22257 11.5959 7.26268 11.5544 7.29088C11.513 7.31907 11.4643 7.33407 11.4145 7.33398H4.58488C4.5351 7.33407 4.48641 7.31907 4.44499 7.29088C4.40356 7.26268 4.37127 7.22257 4.35221 7.17562C4.33315 7.12866 4.32817 7.07699 4.3379 7.02715C4.34764 6.9773 4.37166 6.93153 4.4069 6.89564Z"
    />
    <!-- :fill="sortBy.toLowerCase() !== 'desc' && isActive ? activeColor : defaultColor" -->
  </svg>
</template>

<script lang="ts" setup>
withDefaults(
  defineProps<{
    sortBy: 'asc' | 'desc'
    defaultColor?: string
    activeColor?: string
    isActive?: boolean
  }>(),
  {
    defaultColor: '#E5EDFF',
    activeColor: '#58E2B0',
    isActive: false,
  },
);
</script>

<style scoped></style>
